<template>
  <v-container id="task-list">
    <v-row>
      <v-col cols="12" md="12" class="breadcrumbs">
        <v-breadcrumbs :items="breadcrumbs" :large="true" :divider="'>'">
        </v-breadcrumbs>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12" sm="8" offset-sm="4">
        <div class="text-right">
          <div cols="10" md="1">
            <app-modal-import-task
              :color="'success'"
              :icon="'mdi-plus-circle'"
              :filter="filter"
              @onSave="loadTasks"
            >
              <template v-slot:title>
                Importar {{ isAT || isGov ? "Atividades" : "Tarefas" }}
              </template>
            </app-modal-import-task>

            <app-modal-insert-task
              :edit="false"
              :color="'success'"
              :icon="'mdi-plus-circle'"
              :filter="filter"
              :municipioSolucaoP="municipioSolucaoP"
              @onSaveTask="loadTasks"
              v-if="filter.municipioSolucao.municipioSolucaoId"
            >
              <template v-slot:title>
                Cadastrar {{ isAT || isGov ? "Atividade" : "Tarefa" }}
              </template>
            </app-modal-insert-task>
          </div>
        </div>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <v-data-table
          :headers="headers"
          :items="enabledTasks"
          item-key="name"
          class="elevation-1"
          :footer-props="{ itemsPerPageText: 'Itens por página' }"
        >
          <template v-slot:footer.page-text="items">
            {{ items.pageStart }} - {{ items.pageStop }} de
            {{ items.itemsLength }}
          </template>
          <template v-slot:item="props">
            <tr>
              <td :title="props.item.nome">
                {{ formatTableValues(props.item.nome) }}
              </td>
              <td :title="props.item.descricao">
                {{ formatTableValues(props.item.descricao) }}
              </td>
              <td :title="props.item.municipioSolucao.nome">
                {{ formatTableValues(props.item.municipioSolucao.nome) }}
              </td>
              <td>
                <v-row>
                  <v-col cols="1">
                    <app-modal-insert-task
                      :object="props.item"
                      :edit="true"
                      :color="'warning'"
                      :icon="'mdi-pencil'"
                      :filter="filter"
                      @onSaveTask="loadTasks"
                    >
                      <template v-slot:title>
                        Edição de {{ isAT ? "Atividade" : "Tarefa" }}
                      </template>
                    </app-modal-insert-task>
                  </v-col>

                  <v-col cols="1" class="col-min-width-bigger">
                    <app-modal-delete-task
                      :payload="props.item"
                      @on-save="loadTasks"
                    >
                      <template v-slot:title>
                        Deletar {{ isAT ? "Atividade" : "Tarefa" }}
                      </template>
                    </app-modal-delete-task>
                  </v-col>
                </v-row>
              </td>
            </tr>
          </template>

          <template slot="no-data">
            <div class="progress" v-if="loading">
              <v-progress-circular
                indeterminate
                color="primary"
              ></v-progress-circular>
            </div>

            <div v-else>
              Nenhuma {{ isAT ? "Atividade" : "Tarefa" }} retornada
            </div>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <AppRetrieveTask
          :disabledTasks="disabledTasks"
          @onRecover="loadTasks"
        ></AppRetrieveTask>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import AppModalInsertTask from "@/modules/task/components/city/ModalInsert";
import AppModalDeleteTask from "@/modules/task/components/city/ModalDelete";
import { mapGetters, mapActions } from "vuex";
import AppModalImportTask from "@/modules/task/components/city/ModalImport";
import AppRetrieveTask from "@/modules/task/components/city/RetrieveTask";
import { cityTaskAPI } from "@/modules/city";
import { formatTableValues } from "@/modules/city/components/terms-reference/utils";

export default {
  name: "AppTaskList",
  props: {
    filter: { type: Object, default: () => ({ municipioSolucao: {} }) },
    municipioSolucaoP: {},
  },
  computed: {
    ...mapGetters(["isFullAdmin", "isAT", "isGov"]),
  },
  components: {
    AppModalInsertTask,
    AppModalDeleteTask,
    AppModalImportTask,
    AppRetrieveTask,
  },
  watch: {
    filter: {
      handler(val, oldVal) {
        this.loadTasks();
      },
      deep: true,
    },
  },
  data() {
    return {
      headers: [
        {
          text: "Nome",
          align: "left",
          value: "nome",
        },
        {
          text: "Descrição",
          value: "descricao",
        },
        {
          text: "Solução",
          value: "municipioSolucao.nome",
        },
        {
          text: "Ações",
          value: "acoes",
          sortable: false,
        },
      ],
      breadcrumbs: [
        {
          text: "Grupos de Soluções",
          disabled: true,
          href: "termo-referencia",
        },
        {
          text: "Soluções",
          disabled: true,
          href: "termo-referencia",
        },
        {
          text: "Tarefas",
          disabled: true,
          href: "termo-referencia",
        },
      ],
      munSolucao: {},
      tasks: [],
      enabledTasks: [],
      disabledTasks: [],
      formatTableValues: formatTableValues,
      loading: false,
    };
  },
  methods: {
    ...mapActions(["setLoading"]),
    limpar() {
      this.tasks = [];
      this.enabledTasks = [];
      this.disabledTasks = [];
    },
    loadTasks() {
      var filtros = {
        grupoSolucaoId:
          this.filter.municipioGrupoSolucao &&
          this.filter.municipioGrupoSolucao.municipioGrupoSolucaoId,
        municipioId: this.$route.params.id,
        solucaoId:
          this.filter.municipioSolucao &&
          this.filter.municipioSolucao.municipioSolucaoId,
        tarefaId:
          this.filter.municipioTarefa &&
          this.filter.municipioTarefa.municipioTarefaId,
      };
      this.loading = true;
      this.limpar();
      cityTaskAPI
        .listByCity(filtros)
        .then((resp) => {
          this.tasks = resp.data;

          this.enabledTasks = resp.data.filter(
            (item) => item.desabilitado === false
          );

          this.disabledTasks = resp.data.filter(
            (item) => item.desabilitado === true
          );

          this.loading = false;
        })
        .catch((resp) => {
          this.loading = false;
          this.$notification.error(
            `Erro ao listar ${this.isAT ? "atividades" : "tarefas"}`
          );
        });
    },
  },
  mounted() {
    if (this.isGov) {
      this.headers = [
        {
          text: "Nome",
          align: "left",
          value: "nome",
        },
        {
          text: "Descrição",
          value: "descricao",
        },
        {
          text: "Fases",
          value: "municipioSolucao.nome",
        },
        {
          text: "Ações",
          value: "acoes",
          sortable: false,
        },
      ];

      this.breadcrumbs = [
        {
          text: "Grupos de Fases",
          disabled: true,
          href: "termo-referencia",
        },
        {
          text: "Fases",
          disabled: true,
          href: "termo-referencia",
        },
        {
          text: "Atividades",
          disabled: true,
          href: "eixo",
        },
      ];
    }
    if (this.isAT) {
      this.headers = [
        {
          text: "Nome",
          align: "left",
          value: "nome",
        },
        {
          text: "Descrição",
          value: "descricao",
        },
        {
          text: "Iniciativa",
          value: "municipioSolucao.nome",
        },
        {
          text: "Ações",
          value: "acoes",
          sortable: false,
        },
      ];
      this.breadcrumbs = [
        {
          text: "Grupos de Iniciativas",
          disabled: true,
          href: "termo-referencia",
        },
        {
          text: "Iniciativas",
          disabled: true,
          href: "termo-referencia",
        },
        {
          text: "Atividades",
          disabled: true,
          href: "eixo",
        },
      ];
    }
    this.loadTasks();
  },
};
</script>
<style scoped>
.progress {
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
